import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import PropTypes from 'prop-types';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SimpleList = props => {
    const { dataList, /* name, */ selectAccount} = props
    const classes = useStyles();

    const handleConvertMask = (numberBeneficiary) => {

        if(numberBeneficiary.length > 4){

            let resultConvert = ""
    
            const [ a, b, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 2

            const ultimos = dataConvert.join('').slice(inicioFin,dataConvert.length)
    
            for(let y=0; y < inicioFin; y++){
                resultConvert = resultConvert.concat("X")
            }
    
            resultConvert = a+b+resultConvert+ultimos

            return resultConvert

        }else{

            return numberBeneficiary

        }

    }

    return (
        <List className={classes.root}>
            {
                dataList.map( data => {
                    return (data.PRODUCTALIAS.includes("AHORRO") 
                        ? <ListItem key = {data.PRODUCTBANKID} button onClick={() => selectAccount(data)} >
                                <ListItemAvatar>
                                <Avatar>
                                    <AccountBalanceWalletIcon />
                                </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={`${data.CLIENTNAME}`}
                                    secondary={`${data.PRODUCTALIAS} - ${handleConvertMask(data.PRODUCTBANKID)}`} />
                            </ListItem>
                            :
                            null)
                })
            }
        </List>
    );
};

SimpleList.propTypes = {
    dataList: PropTypes.array.isRequired,
};

export default SimpleList;